import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

/**
 * Add subTenantId to request body if needed
 */
const attachSubTenantIdToBody = (data) => {
  try {
    let jsonData = JSON.parse(data);

    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId) {
      jsonData.subTenantDTO = { id: decodedToken.subTenantId };
    }

    return JSON.stringify(jsonData);
  } catch {
    return data; // fallback if already JSON
  }
};

/**
 * Common headers
 */
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": decodedToken?.tenantApiKey,
  };

  if (
    decodedToken?.roles?.includes("TENANT_ADMIN") ||
    decodedToken?.subTenantId === undefined
  ) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const CleaningTraceabilityItemApi = {
  // Create Traceability Item
  CreateTraceabilityItemApi: (data) => {
    data = attachSubTenantIdToBody(data);
    return apiApp
      .post(`/cleaningTraceabilityItem`, data, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Update Traceability Item
  PutTraceabilityItemApi: (TraceabilityItemID, data) => {
    data = attachSubTenantIdToBody(data);
    return apiApp
      .put(`/cleaningTraceabilityItem/${TraceabilityItemID}`, data, {
        headers: getHeaders(),
      })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // List Traceability Items
  ListTraceabilityItemApi: (page, limit) => {
    return apiApp
      .get(
        `/cleaningTraceabilityItem?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Get Single Traceability Item
  SingleTraceabilityItemApi: (TraceabilityItemID) => {
    return apiApp
      .get(
        `/cleaningTraceabilityItem/${TraceabilityItemID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Delete Traceability Item
  DeleteTraceabilityItemApi: (TraceabilityItemID) => {
    return apiApp
      .delete(
        `/cleaningTraceabilityItem/${TraceabilityItemID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },
};

export default CleaningTraceabilityItemApi;
